import 'reflect-metadata';
import { LayoutType } from 'src/components/layout/layout';
import LayoutForm from 'src/components/layout/form/form';
import RestorePassword from 'src/components/pages/restore-password/restore-password';
import { GetStaticProps, GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect } from 'react';
import styles from './restore-password.module.scss';
import { RestorePasswordPageActions } from 'src/store/pages/restore-password/actions';
import { i18n } from 'next-i18next.config';
import { useDispatch } from 'react-redux';
import { wrapper } from 'src/store/store';
import { configuration } from '../../configurations/configuration';
import Head from 'next/head';

const ProfileChangePasswordPage = (): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      dispatch(RestorePasswordPageActions.resetState());
    },
    []
  );

  return (
    <>
      <Head>
        <title>US Mineral Exchange | Restore Your Password</title>
        <link
          rel='canonical'
          href={`${process.env.NEXT_PUBLIC_URL}/restore-password`} />
      </Head>
      <LayoutForm className={styles.restorepassword}>
        <RestorePassword />
      </LayoutForm>
    </>
  );
};

ProfileChangePasswordPage.layout = LayoutType.HOME;

export default ProfileChangePasswordPage;

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
  () => async ({ locale, preview }: GetStaticPropsContext) => {
    if (preview) {
      return {
        redirect: {
          permanent: false,
          destination: configuration.redirectPaths.checkPreview
        }
      };
    }

    return {
      props: {
        ...(await serverSideTranslations(locale ?? i18n.defaultLocale, [
          'common',
          'components:layout',
          'components:pages:restore-password'
        ]))
      },
      revalidate: configuration.revalidation.timeSec
    };
  }
);
